import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'lib-info-tile',
  templateUrl: './info-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class InfoTileComponent {
  readonly label: InputSignal<string> = input.required<string>();
  readonly value: InputSignal<string | number | null | undefined> = input<string | number | null | undefined>(null);
  readonly placeholder: InputSignal<string> = input<string>('-');

  readonly displayValue: Signal<string | number> = computed(() => {
    const value: string | number | null | undefined = this.value();
    if (value === null || value === undefined || value === '') return this.placeholder();
    return value;
  });

  readonly isEmpty: Signal<boolean> = computed(() => {
    const value: string | number | null | undefined = this.value();
    return value === null || value === undefined || value === '';
  });
}
